import { useState } from 'react'
import axios from 'axios'
import { useQuery } from "react-query"

const URL = '/api/data/exceptions/'

const useOrderExceptions = () => {
  const [data, setData] = useState([])
  const token = localStorage.getItem('token')

  const {isLoading} = useQuery(
    "order-exceptions",
    async () => {
      const r = await axios.get(URL, {
        headers: {
          Authorization: `Token ${token}`
        }
      })
      return r.data
    },
    {
      staleTime: Infinity,
      refetchInterval: false,
      onSuccess: (data) => {
        setData(data)
      },
      onError: (err) => {
        console.log(err)
      }
    }
  )

  return [data, isLoading]
}

export default useOrderExceptions